//import MUI
import SurfingIcon from '@mui/icons-material/Surfing';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getEleves } from "../../store/selectors.js";

//Utils 
import elevesSorter from '../../utils/eleves_sorter.js';

function CreneauRider({ idEleve }) {

    let prenomRider = "";
    let allEleves = useSelector(getEleves);
    let selectedEleves = allEleves.filter((eleve) => eleve.checked === true);
    selectedEleves = elevesSorter(selectedEleves);

    let index = selectedEleves.findIndex((eleve) => eleve.id === idEleve); // 

    let colorIndex = index < 8 ? index + 1 : index - ((8 * Math.trunc(index / 8)) - 1); // 


    return (

        <div className="creneau-rider">
            <SurfingIcon className={"surfer-color-" + colorIndex} />
            <p>{selectedEleves[index].prenom}</p>
        </div>
    );
}

export default CreneauRider;